let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5ncEu")).then(() => parcelRequire('bC3h9'));